import { useMemo } from 'react';
import { prop } from 'ramda';
import { useFormatter } from '@core/js/hooks/useFormatter';
import { useGameConfigurationSelector } from '@core/js/store/hooks';
import { useComponentConfig } from '@core/js/hooks/component/useComponentConfig';

import { WINNER_INFO } from '@theme/js/components/main/TopWinners/constants';
import { useDynamicReducerSelector } from '@core/js/components/main/TopWinners/store';

/* Lugano changes */
const formatNickname = (str) => {
    if (!str) {
        return null;
    }

    switch (str.length) {
        case 1:
        case 2:
            return `${str}**`;
        case 3:
            return `${str.slice(0, 2)}**`;
        case 4:
            return `${str.slice(0, 3)}**`;
        default:
            return `${str.slice(0, 4)}**`;
    }
};
/* Lugano changes */

export const useTopWinners = () => {
    const formatter = useFormatter();
    const games = useGameConfigurationSelector(prop('games'));
    const { winnersInfo = WINNER_INFO.INITIALS, minimumAmount } = useComponentConfig(); // { Lugano changes - added minimumAmount }
    const topWinners = useDynamicReducerSelector(prop('topWinners'));

    return useMemo(() => {
        if (!games) {
            return [];
        }

        return topWinners
            .filter(({ gameType }) => games[gameType])
            /* Lugano changes */
            .filter(({ winAmount: { amount } }) => {
                if (!minimumAmount) {
                    return true;
                }

                return Number(amount) >= Number(minimumAmount);
            })
            /* Lugano changes */
            .map(winner => {
                const {
                    id, gameType, nickname, lastNameInitial, firstNameInitial,
                    winAmount: { amount, currencyCode },
                    jackpotWinAmount: { jackpotAmount, jackpotCurrencyCode }
                } = winner;
                const formattedNickname = formatNickname(nickname); /* Lugano changes */
                const initials = `${firstNameInitial}. ${lastNameInitial}.`;
                const player = winnersInfo === WINNER_INFO.INITIALS
                    ? initials
                    : formattedNickname || initials; /* Lugano changes */
                const winAmount = Number(amount) === 0
                    ? formatter.formatCurrency(jackpotAmount, { jackpotCurrencyCode })
                    : formatter.formatCurrency(amount, { currencyCode });

                return {
                    id,
                    player,
                    winAmount,
                    gameCode: gameType,
                    gameName: games[gameType].name
                };
            });
    }, [winnersInfo, topWinners, formatter, games, minimumAmount]);
};
